/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { ReactElement, useEffect, useState } from 'react';

import {
  Container,
  Grid,
  Paragraph,
  Link,
  GridItem,
  ButtonPattern,
} from '@constellation/core';
import { useContent } from '@interstellar/react-app-content';
import { useNavigate } from '@interstellar/react-app-routing';
import PageHeading from 'components/pageHeading/PageHeading';
import { QRCodeSVG } from 'qrcode.react';

import { SwitchToMobileContent } from './SwitchToMobileContent';
import StyledBox from '../../components/style/styledBox/StyledBox';
import getUrlWithEnv from '../../utils/getUrlWithEnv';

function SwitchToMobile(): ReactElement {
  const [qrCodeUrl, setQrCodeUrl] = useState<string>('');
  const { switchToMobileContent } = useContent<SwitchToMobileContent>();
  const navigate = useNavigate();

  const handleNavigation = (path: string): void => {
    navigate(path);
  };

  useEffect(() => {
    const URL = '/bds/{{env}}/online-for-business/register/about-the-business';

    const path = window.location.pathname;
    const qrUrl = getUrlWithEnv(URL, path);

    setQrCodeUrl(window.location.origin + qrUrl);
  }, []);

  return (
    <Container padding="none">
      {switchToMobileContent &&
        switchToMobileContent.map(
          ({ serviceName, header, content, previousLink, previousHref }) => (
            <React.Fragment key="content">
              <PageHeading serviceName={serviceName} header={header} />
              <Grid alignX="center" alignY="top">
                <GridItem lg={8}>
                  <StyledBox>
                    <Grid alignX="center" alignY="center">
                      <GridItem>
                        <Paragraph>{content}</Paragraph>
                      </GridItem>
                      <GridItem sm={12} md={5} lg={4}>
                        <Container marginBottom="05">
                          <QRCodeSVG
                            value={qrCodeUrl}
                            size={200}
                            includeMargin={false}
                          />
                        </Container>
                      </GridItem>
                      <GridItem>
                        <ButtonPattern marginBottom="none">
                          <Link
                            iconPosition="left"
                            onClick={() => handleNavigation(previousHref)}
                          >
                            {previousLink}
                          </Link>
                        </ButtonPattern>
                      </GridItem>
                    </Grid>
                  </StyledBox>
                </GridItem>
                <GridItem lg={4}>
                  {/* FAQs accordian */}
                  <Grid>
                    <GridItem />
                  </Grid>
                </GridItem>
              </Grid>
            </React.Fragment>
          ),
        )}
    </Container>
  );
}

export default SwitchToMobile;
